import React from "react";
import { Link } from "react-router-dom";
import styles from "./NewsPage.module.css";
import { newsItems } from "../data/newsItems";

export default function NewsPage() {
  return (
    <section className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Aktuelles &amp; Pressemitteilungen</h1>
        <p className={styles.subtitle}>
          Einblicke in Grundsteinlegungen, Projektstarts und Veröffentlichungen.
        </p>
      </header>

      <div className={styles.list}>
        {newsItems.map((item, index) => {
          const imageJpg = item.image;
          const imageBase = imageJpg.replace(/\.jpg$/i, "");
          const imageAvif = `${imageBase}.avif`;
          const imageWebp = `${imageBase}.webp`;
          const raw = item.body[0] ?? "";
          const maxLen = 230;

          let teaser = raw;
          if (raw.length > maxLen) {
            const cut = raw.slice(0, maxLen).replace(/\s+\S*$/, "");
            teaser = cut + " ...";
          }

          return (
            <article
              key={item.slug}
              className={`${styles.item} ${
                index % 2 === 1 ? styles.itemAlt : ""
              }`}
            >
              <Link to={`/aktuelles/${item.slug}`} className={styles.itemInner}>
                <div className={styles.media}>
                  <div className={styles.mediaInner}>
                    <picture>
                      <source srcSet={imageAvif} type="image/avif" />
                      <source srcSet={imageWebp} type="image/webp" />
                      <img
                        src={imageJpg}
                        alt={item.title}
                        loading={index === 0 ? "eager" : "lazy"} 
                        decoding="async"
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 60vw, 540px"
                      />
                    </picture>
                  </div>
                </div>

                <div className={styles.text}>
                  <div className={styles.metaRow}>
                    <time className={styles.date} dateTime={item.date}>
                      {item.dateLabel ?? item.date}
                    </time>
                  </div>

                  <h2 className={styles.itemTitle}>{item.title}</h2>
                  <p className={styles.itemExcerpt}>{teaser}</p>

                  <span className={styles.more}>
                    Beitrag öffnen&nbsp;<span aria-hidden="true">›</span>
                  </span>
                </div>
              </Link>
            </article>
          );
        })}
      </div>
    </section>
  );
}
